import { render, staticRenderFns } from "./SettingsConflictDetectionToolViewTag.vue?vue&type=template&id=f45ef0b8&lang=pug&"
import script from "./SettingsConflictDetectionToolViewTag.vue?vue&type=script&lang=js&"
export * from "./SettingsConflictDetectionToolViewTag.vue?vue&type=script&lang=js&"
import style0 from "./SettingsConflictDetectionToolViewTag.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports